// extracted by mini-css-extract-plugin
export var errorIcon = "_p8-1";
export var nameLogo = "_p8-0";